<template>
    <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-10">
        <h5 class="mt-3">Search:</h5>
        <div class="d-flex justify-content-center mb-5">
          <div class="input-group">
            <input
              @keyup.enter="checkinSearch"
              class="form-control"
              type="text"
              id="qrcodeSearchInput"
              name="qrcodeSearchInput"
              v-model="qrcodeSearchInput"
              placeholder="Search QR Number / Phone"
              aria-label="Search QR Number / Phone"
              autocomplete="off"
              autofocus
            />
            <div class="input-group-append">
              <span
                class="input-group-text pl-4 pr-4"
                id="searchbtt"
                @click.prevent="checkinSearch"
              ><i
                  class="fas fa-search text-grey"
                  aria-hidden="true"
                ></i></span>
            </div>
          </div>
        </div>
        <div
          v-if="loadingSearch"
          class="text-center"
        >
          <b-spinner class="align-middle"></b-spinner>
          <strong>Loading...</strong>
        </div>
        <transition name="slide-fade">
          <div
            class="qrcodechk "
            v-if="hasCoupon"
          >
            <div>
              <b-jumbotron
                v-if="!loadingSearch"
                :bg-variant="getMemberStatus"
                text-variant="white"
              >
                <template v-slot:header  v-if="isActivePackage && qrcodeObj.type!='UNLIMIT'">
                {{ qrcodeObj.count }}/{{ qrcodeObj.session_max }} Redeem
                </template>
                <template v-slot:header v-else-if="isActivePackage && qrcodeObj.type=='UNLIMIT'">
                  UNLIMITED
                </template>
                <template v-slot:header v-else>
                  Coupon Expired [{{ qrcodeObj.count }}/{{ qrcodeObj.session_max }}]
                </template>

                <template
                  v-slot:lead
                >
                  <b-container fluid>
                  <b-row>
                    <b-col>
                      <div>Phone: <strong>{{ qrcodeObj.member_phone }}</strong></div>
                      <div v-if="qrcodeObj.member_email!=null">Email: <strong>{{ qrcodeObj.member_email }}</strong></div>
                    </b-col>
                  </b-row>
                  <hr />
                  <b-row>
                      <b-col>
                        Valid to: 
                        <strong>
                          {{
                            (qrcodeObj.expiredate==null)?
                            'No visit yet..':formatDateDisplayLocal(qrcodeObj.expiredate)
                          }}</strong>
                        
                      </b-col>
                      <b-col class="text-right">
                        <b-button
                        variant="warning"
                        @click.prevent="displayQR()"
                      >View QR Code</b-button>
                    </b-col>
                  </b-row>
                  </b-container>
                </template>
                
                <template v-if="qrcodeObj.type!='UNLIMIT'">
                  <div>
                    <b-container fluid>

                      <!-- Main table element -->
                      <b-table
                        show-empty
                        small
                        stacked="md"
                        striped
                        table-variant="secondary"
                        hover
                        :items="qrcodeObj.qrcheckins"
                        :fields="fields"
                        :busy="loadingVisit"
                      >
                        <template v-slot:table-busy>
                          <div class="text-center my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong>Loading...</strong>
                          </div>
                        </template>

                        <!-- A custom formatted column -->
                        <template v-slot:cell(checkin_at)="data">
                          {{ getFormatDateTimeDisplay(data.value) }}
                        </template>
                        
                        <template v-slot:cell(actions)="row">    
                          <b-button
                            size="sm"
                            @click.prevent="removeCheckin(row.item)"
                            class="mr-1"
                            variant="secondary"
                          >
                            <i class="fas fa-trash-alt"></i>
                          </b-button>
                        </template>
                      </b-table>
                    </b-container>
                  </div>
                </template>

                <template v-if="qrcodeObj.type!='UNLIMIT'">
                 <div class="mt-4 ml-3 mr-3"  v-if="!loadingCheckin">
                <b-button
                  v-if="isActivePackage"
                  block 
                  size="lg"
                  variant="primary"
                  @click.prevent="performCheckin(qrcodeObj.qr_number)"
                >Redeem</b-button>
                </div>
                  <div class="text-center" v-else>
                    <b-spinner variant="success" label="Spinning"></b-spinner>
                  </div>
                </template>
                
                  
                

              </b-jumbotron>
            </div>
          </div>
          <div v-if="hasNoCoupon">
            <h3 class="text-center red">Coupon not found</h3>
          </div>
        </transition>
        <h3
          v-if="hasError"
          class="text-center red"
        >
        {{ errorMessage }}
        </h3>

        <b-container class="bv-example-row">
        <b-row>
            <b-col>
              <modal name="qrgenbox"
                          :width="500"
                          :height="500"
                          :adaptive="true"
                          >
                <div class="m-4">
                  <h4 class="text-center">{{(qrcodeObj!=null)?formatTypeCoupon(qrcodeObj.type):""}}</h4>
                  <h5 class="text-center">EXPIRE DATE: {{(qrcodeObj!=null && qrcodeObj.expiredate!=null)?formatDateDisplayLocal(qrcodeObj.expiredate):""}}</h5>
                </div>
                <div v-if="qrnum" class="output">
                    <b-img :src="newQRCode" alt="QRCode" center />
                </div>
                <h4 class="mt-4 text-center">{{ (qrcodeObj!=null)?qrcodeObj.qr_number:"" }}</h4>
            </modal></b-col>
        </b-row>
        </b-container>

        <!--<test-table></test-table>-->
      </div>
      </div>
    </div>       
</template>

<script>

import Vue from "vue";
import QRious from "qrious";
import VModal from "vue-js-modal";
Vue.use(VModal, {  });

import {
  formatDateDisplay,
  formatDateTimeDisplay,
  getTimeFromDateFormat
} from "./../js/utils/date.js";

export default {
  components: {
    //CheckinSearch,
    //TestTable,

  },
  data() {
    return {
      loadingSearch: false,
      loadingVisit:false,
      loadingRemove:false,
      loadingCheckin:false,
      qrcodeObj:null,
      qrcodeSearchInput: null,
      //timeout: null,
      hasCoupon: false,
      hasNoCoupon:false,
      isActivePackage: false,
      hasError:false,
      errorMessage: null,
      maxcount:null,
      fields: [
        {
          key: "checkin_at",
          label: "Checkin At",
        },
        {
          key: "actions",
          label: "Remove",
        },
      ],
      items: null,
      qrnum:null,
      qrcodedisplay: new QRious({ size: 300 }),
    };
  },
  computed: {
    getMemberStatus() {
      if (this.isActivePackage) {
        return "success";
      } else {
        return "danger";
      }
    },
    newQRCode() {
        this.qrcodedisplay.value = this.qrnum;
        return this.qrcodedisplay.toDataURL();
    },
  },
  methods: {
    getTimeFromDateFormat,
    resetSearch() {

      this.isActivePackage = false;

      this.hasError = false;
      this.errorMessage = null;
      this.hasCoupon = false;
      this.hasNoCoupon = false;

      this.items = null;
      this.maxcount = null;

      //clearTimeout(this.timeout);
    },
    async checkinSearch() {
      
      let self = this;
      //console.log(this.qrcodeSearchInput);
      if (this.qrcodeSearchInput == "" || this.qrcodeSearchInput == null) {
        return false;
      }

      this.loadingSearch = true;
      this.loadingVisit = true;
      //==== Reset Member Checkin Jumbotron
      this.resetSearch();

      //await axios.get("/sanctum/csrf-cookie");

      await axios
      .get("/api/qrcodes/find", {
          params: {
            qrnumber: this.qrcodeSearchInput
          }
        })
        .then(response => {
          //console.log(response.data);

          self.qrcodeSearchInput = null;
          //console.log("len " + response.data.data.length);
          //console.log(response.data);
          if (response.data.length == 0) {
            self.hasNoCoupon = true;
          }
          else{
            self.hasCoupon = true;
            self.qrcodeObj = response.data;
            

            if(self.qrcodeObj.status=='ACTIVE'){
              self.isActivePackage = true;
            }

            if (self.qrcodeObj.qrcheckins.length >0) {
              self.items = self.qrcodeObj.qrcheckins;
              //----- Generate Checkin Table
              //console.log(self.qrcodeObj.qrcheckins[0].checkin_at);
            }

            self.qrnum = self.qrcodeObj.qr_number;
          } 

          //console.log(response.data.data);
        })
        .catch(function(error) {
          
          self.hasError = true;
          self.errorMessage = "Error Occured";

        })
        .finally(() => {
          this.qrcodeSearchInput = null;
          this.loadingSearch = false;
          this.loadingVisit = false;
          /*this.timeout = setTimeout(() => {
            this.resetSearch();
          }, 30000);*/
        });


    },

    async performCheckin(qr_number) {

      let self = this;
      //console.log(memberpackage);
      this.loadingCheckin = true;
      await axios
        .post("/api/qrcodes/deduct", {
          qr_number: qr_number
        })
        .then(response => {

          if(response.data.status =='SUCCESS'){
            self.qrcodeSearchInput = qr_number;
            self.checkinSearch();
          }
          else{
            self.hasError = true;
            self.errorMessage = 'Can not redeem';
          }
          

        })
        .catch(function(error) {
          
          //console.log(8888888);
          //console.log(error.response.data.errors.message);
          //if(error.response.data.errors.message =)
          self.hasError = true;
          self.errorMessage = error.response.data.errors.message;

        })
        .finally(() => {

          this.loadingCheckin = false;
          /*this.timeout = setTimeout(() => {
            this.resetSearch();
          }, 30000);*/
        });
    },
    async removeCheckin(item) {

      if (confirm("Do you really want to remove?")) {
        let self = this;
        this.loadingRemove = true;
        await axios
          .post("/api/qrcodes/visitremove", {
            id: item.id,
          })
          .then((response) => {
            if(response.data.status =='DELETE_SUCCESS'){
              self.qrcodeSearchInput = self.qrcodeObj.qr_number;
              self.checkinSearch();
            }
          })
          .catch(function(error) {
            self.hasError = true;
            self.errorMessage = error.response.data.errors.message;
        })
        .finally(() => {
          this.loadingRemove = false;
        });
      }
    },
    showModal() {
      this.$modal.show(
        'qrgenbox',
        {
          //--- Component property
          //passtext: "This text is passed as a property"
          //selfmodal: this.$modal,
        },
        {
          //-- Modal Params
          //height:300,
          //width:300,
        },
        {
          //-- Modal event listener
          "before-close": event => {
            //console.log('ddd');
          },
          "before-open": event => {

          }
        },
        {}
      );
    },
    displayQR(){
      this.showModal();
      //this.$emit("close");
    },
    getFormatDateTimeDisplay(date) {
      return formatDateTimeDisplay(date);
    },
    formatDateDisplayLocal(date) {
      return formatDateDisplay(date);
    },
    formatTypeCoupon(type){
      switch (type) {
        case '5D':
          return '5 DAYS PASS'
          break;
      case '10D':
          return '10 DAYS PASS'
          break;
      }
    }
  }
};
</script>
<style scoped>
#searchbtt {
  cursor: pointer;
}
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0s cubic-bezier(1, 0, 0, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
.red {
  color: maroon;
}
.checkinbox {
  width: 20px;
  height: 20px;
}
.classcard {
  color: #000;
}
</style>